export default "__VITE_ASSET__kSjUA0gd__"